import PropTypes from 'prop-types';
import * as React from 'react';
import { RenderComp } from '../core/render-comp.component.js';
import { renderWithRef } from '../core/render-with-ref.js';

const propTypes = {
    fullWidthImage: PropTypes.bool,
    height: PropTypes.oneOf([
        'standard',
        'short'
    ]),
    skin: PropTypes.oneOf([
        'standard',
        'holiday'
    ]),
    staggered: PropTypes.bool,
    textHorizontalAlign: PropTypes.oneOf([
        'left',
        'center',
        'right'
    ]),
    // TODO: textBackground=transparent, and no backgroundColor, then set the backgroundColor as 'transparent'
    // add deprecation warning
    textBackground: PropTypes.oneOf([
        'standard',
        'transparent'
    ]),
    textVerticalAlign: PropTypes.oneOf([
        'center',
        'top',
        'bottom'
    ]),
    withNav: PropTypes.bool,
    hideImageOnMobile: PropTypes.bool,
    imageBehindTextOnMobile: PropTypes.bool
};
const propKeysToRemove = Object.keys(propTypes);
const StandardHero = renderWithRef('StandardHero', propTypes, (props, ref)=>{
    const { children , fullWidthImage , height , skin , staggered , textHorizontalAlign , textBackground , textVerticalAlign , withNav , hideImageOnMobile , imageBehindTextOnMobile  } = props;
    const classNameSet = new Set([
        'swan-standard-hero'
    ]);
    if (skin !== 'standard') classNameSet.add(`swan-standard-hero-skin-${skin}`);
    if (textVerticalAlign !== 'center') classNameSet.add(`swan-standard-hero-text-vertical-align-${textVerticalAlign}`);
    if (textHorizontalAlign !== 'left') classNameSet.add(`swan-standard-hero-text-align-${textHorizontalAlign}`);
    if (textBackground === 'transparent') classNameSet.add('swan-standard-hero-text-transparent-background');
    if (fullWidthImage) classNameSet.add('swan-standard-hero-full-width-image');
    if (staggered) classNameSet.add('swan-standard-hero-staggered');
    if (height === 'short') classNameSet.add('swan-standard-hero-short');
    if (withNav) classNameSet.add('swan-standard-hero-with-left-hand-navigation');
    if (hideImageOnMobile) classNameSet.add('swan-standard-hero-hide-image-on-mobile');
    if (imageBehindTextOnMobile) classNameSet.add('swan-standard-hero-image-behind-text-on-mobile');
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(RenderComp, {
        root: "div",
        forwardedRef: ref,
        propKeysToRemove: propKeysToRemove,
        classNames: classNameSet,
        props: props
    }, children));
});
StandardHero.defaultProps = {
    fullWidthImage: false,
    height: 'standard',
    skin: 'standard',
    staggered: false,
    textHorizontalAlign: 'left',
    textBackground: 'standard',
    textVerticalAlign: 'center',
    withNav: false
};

export { StandardHero };
